/**
 * Projected fields for the Created panel's profile backer-rewards list.
 */
export const BACKER_REWARDS_FIELDS = [
  'marketPubkey',
  'marketTitle',
  'marketImageUrl',
  'marketState',
  'vaultD6',
  'supplyD6',
  'userShareD6',
  'backedD6',
  'backedTotalD6',
  'earnedD6',
  'claimedTotalD6',
  'canClaim',
] as const;
